export default __webpack_public_path__ + "static/media/backoffice.7246c09e.jpg";